import { render, staticRenderFns } from "./student-icon.vue?vue&type=template&id=22a50eba"
import script from "./student-icon.vue?vue&type=script&lang=js"
export * from "./student-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports